export enum AccountType {
  ABO = "BUSINESS_OWNER",
  REGISTERED = "CUSTOMER",
  MEMBER = "MEMBER",
  EMPLOYEE = "EMPLOYEE",
}

export enum RegistrationType {
  REQUIRED = "REQUIRED",
  OPTIONAL = "OPTIONAL",
}

export enum CategoryType {
  MYSHOP = "myshop",
  PDP = "pdp",
  MYLIST = "mylist",
  SUBSCRIPTION = "subscription",
  MEPANEL = "mepanel",
}

export interface Locale {
  locale: string;
  lang: string;
}

export interface ShareRegistrationData {
  type: AccountType;
  labelKey: string;
}
export interface ShareRegistrationConfig {
  [key: string]: RegistrationType;
}
export type Role = "ABO" | "REGISTERED" | "MEMBER" | "EMPLOYEE";

export interface Groups {
  [groupName: string]: Role[];
}

export interface ChannelConfigs {
  lineUrl?: string;
  fbUrl?: string;
  whatsappUrl?: string;
  copyLinkEnable?: boolean;
  emailEnable?: boolean;
  moreOptionsEnable?: boolean;
  sharelinkPath?: string;
}

export interface Config {
  locales: Locale[];
  shareRegistrationConfig: ShareRegistrationConfig;
  shareRegistrationData: ShareRegistrationData[];
  sharebarChannelConfigs: ChannelConfigs;
  mandatoryRegistration: CategoryType[];
  roles: Role[];
  groups: Groups;
  customChatBotIcon: string;
  toastDisplayTime?: number;
  country: string;
  tenant: string;
  currency: string;
  timezone: string;
  tealiumProfile: string;
  contactNickName?: boolean;
  sopMegaMenuEnabled?: boolean;
  settingsAndPreferencesHideSignIn?: boolean;
}
